module.exports = __webpack_public_path__ + "static/media/left.a4dca9ae.svg";